import { getComponentId } from 'features/assetDatabase/components/assetOverview/assetDetails/imagesSection/utils'
import { useEffect, useState } from 'react'
import {
  GeckoComponentCoords,
  GeckoEntry,
  GeckoInspection,
  GeckoMeasurementUnit,
} from 'types'

export const useGeometricPinCoords = (
  geometricPins: readonly GeckoEntry[],
  inspections: readonly GeckoInspection[],
  componentID?: string,
  inspectionID?: string
) => {
  const [selectedCoords, setSelectedCoords] = useState<
    GeckoComponentCoords | undefined
  >(undefined)

  useEffect(() => {
    if (geometricPins.length === 0) return

    const pinData = geometricPins[0].data
    if (!pinData.x_measurement_unit || !pinData.y_measurement_unit) return

    const xUnit = GeckoMeasurementUnit.GetByID(
      pinData.x_measurement_unit as string
    )
    const yUnit = GeckoMeasurementUnit.GetByID(
      pinData.y_measurement_unit as string
    )
    if (!xUnit || !yUnit) return

    const coords = GeckoComponentCoords.CreateFromValues(
      getComponentId(inspections, componentID, inspectionID) as string,
      pinData.x as number,
      xUnit,
      pinData.y as number,
      yUnit
    )
    setSelectedCoords(coords)
  }, [componentID, geometricPins, inspectionID, inspections])

  return {
    selectedCoords,
    setSelectedCoords,
  }
}
